/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-20 15:51:16
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-11 14:46:43
 */
const insurance = [
    {
      path: '/insurance/list',
      name: 'insuranceList',
      component: () => import('../views/insurance/list'),
    },
    {
        path: '/insurance/detail/:id',
        name: 'insuranceDetail',
        component: () => import('../views/insurance/detail'),
    },
    {
      path: '/insurance/settlement-guide',
      name: 'settlementGuide',
      component: () => import('../views/insurance/settlement-guide'),
  },
  ]
  export default insurance


// WEBPACK FOOTER //
// ./src/router/insurance.js